import { render, staticRenderFns } from "./ViserChartDemo.vue?vue&type=template&id=1fd923d1&scoped=true"
import script from "./ViserChartDemo.vue?vue&type=script&lang=js"
export * from "./ViserChartDemo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd923d1",
  null
  
)

export default component.exports